
<Modal :mayCancel="true" v-on:cancel="onDone">
  <p>You’ve succesfully added this whiteboard to your account.</p>
  <div class="ButtonRow-FlexRight">
    <button class="WBMBigButton m-primary" v-on:click="onDone">OK</button>
  </div>
</Modal>
